var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSightcallCircleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 186,
    height: 186,
    viewBox: "0 0 186 186",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 93,
    cy: 93,
    r: 93,
    fill: "#EBE9FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.9897 102.61L35.1158 102.529C64.3572 116.918 103.469 119.997 131.349 102.713C131.349 102.713 130.308 92.3911 103.891 83.2097C144.765 82.7673 158.555 101.956 158.555 101.956C122.838 131.071 67.1095 130.677 34.9897 102.61Z",
    fill: "#0E78F5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M157.563 90.1523L157.465 90.231C128.2 75.8198 89.0861 72.7405 61.2057 90.0491C61.2057 90.0491 62.2469 100.334 88.6613 109.552C47.8083 109.97 34 90.779 34 90.779C69.7382 61.6643 125.469 62.0256 157.563 90.1523Z",
    fill: "#0E78F5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSightcallCircleIcon);
export default __webpack_public_path__ + "static/media/sightcall-circle-icon.3f5d31288ef677998cc874885ac3aea7.svg";
export { ForwardRef as ReactComponent };